/**
 * Catalogue manifest for `@barel/i18n`.
 *
 * Lists every namespace shipped with the package + the supported locales.
 * The runtime uses this to lazy-load JSON catalogues; the CLI gate
 * (`tools/i18n-check`) walks the same manifest to assert FR/EN parity.
 */
export const SUPPORTED_LOCALES = ['fr', 'en'];
export const DEFAULT_LOCALE = 'fr';
export const FALLBACK_LOCALE = 'fr';
/**
 * Feature namespaces. Order matches `plans/03-architecture/i18n.md`.
 * Each namespace ships as `src/locales/<locale>/<namespace>.json`.
 */
export const NAMESPACES = [
    'common',
    'auth',
    'inbox',
    'voice',
    'businesses',
    'campaigns',
    'leads',
    'relances',
    'settings',
    'billing',
    'onboarding',
    'ftu',
    'extension',
    'errors',
    'shell',
    'accounts',
    'notifications',
];
export const DEFAULT_NAMESPACE = 'common';
/**
 * TODO marker copied verbatim into EN catalogues whenever the prototype is
 * FR-only. Wave 10 elevates this from warning to error in `i18n:check`.
 */
export const TODO_EN_MARKER = '__TODO_EN__';
//# sourceMappingURL=locales.js.map